export const MAP_FILTER_AUTO_DISABLE_RADIUS_KM = 75;
export const MAP_FILTER_AUTO_REENABLE_RADIUS_KM = 50;
export const MAP_FILTER_AUTO_DISABLE_RATIO = 3.5;
export const MAP_FILTER_MAX_RADIUS_KM = 5000;


